export default function BookIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6654 3.33342C16.6654 2.41294 15.9192 1.66675 14.9987 1.66675H5.83203C4.45132 1.66675 3.33203 2.78604 3.33203 4.16675V15.8334C3.33203 17.2141 4.45132 18.3334 5.83203 18.3334H15.4154C15.8756 18.3334 16.2487 17.9603 16.2487 17.5001C16.2487 17.0398 15.8756 16.6667 15.4154 16.6667H5.83203C5.37179 16.6667 4.9987 16.2937 4.9987 15.8334C4.9987 15.3732 5.37179 15.0001 5.83203 15.0001H14.9987C15.9192 15.0001 16.6654 14.2539 16.6654 13.3334L16.6654 3.33342ZM5.83203 13.3334C5.53984 13.3334 5.25935 13.3835 4.9987 13.4757L4.9987 4.16675C4.9987 3.70651 5.37179 3.33341 5.83203 3.33341L7.08203 3.33342V6.99901C7.08203 8.23544 8.52411 8.91088 9.47397 8.11934L10.4154 7.33484L11.3568 8.11934C12.3066 8.91088 13.7487 8.23544 13.7487 6.99901V3.33342H14.9987V13.3334H5.83203ZM12.082 3.33342H8.7487V6.55421L9.88188 5.6099C10.1909 5.35237 10.6398 5.35237 10.9489 5.6099L12.082 6.55421V3.33342Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
